export default {
    wig_state_change_operation_complete_invalid_phone_number_warning:
        'The operation is complete. No message was sent to the customer because the phone number is invalid',
}
